<template>
    <div class="pdf-view">
        <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
            <div class="btn-group" role="group">
                <button type="button" class="btn btn-sm" :class="tipo === 'pelotao' ? 'btn-pmes-primary' : 'btn-light'"
                    @click="selecionar('pelotao')">PDF por pelotão</button>
                <button type="button" class="btn btn-sm" :class="tipo === 'horario' ? 'btn-pmes-primary' : 'btn-light'"
                    @click="selecionar('horario')">PDF por horário</button>
            </div>
            <a v-if="pdfUrl" :href="pdfUrl" target="_blank" class="btn btn-sm btn-light"
                title="Abrir em nova aba">
                <i class="fa fa-up-right-from-square"></i> Abrir em nova aba
            </a>
        </div>

        <div v-if="carregando" class="text-muted text-center p-5">Carregando PDF...</div>
        <div v-else-if="erro" class="text-danger text-center p-5">{{ erro }}</div>
        <iframe v-show="!carregando && !erro && pdfUrl" :src="pdfUrl" class="pdf-frame" title="Visualização do QTS"></iframe>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Prop, Watch } from 'vue-property-decorator';
import QtsSemanalService from "@/service/v1/sigap/QtsSemanalService";

@Options({
    name: "QtsSemanalPdfView",
})
export default class QtsSemanalPdfView extends Vue {

    @Prop() readonly qtsSemanalId!: any

    public service = new QtsSemanalService();
    public tipo: 'pelotao' | 'horario' = 'pelotao';
    public pdfUrl = '';
    public carregando = false;
    public erro = '';

    created() {
        this.carregar();
    }

    @Watch('qtsSemanalId')
    public recarregar() {
        this.carregar();
    }

    public selecionar(tipo: 'pelotao' | 'horario') {
        if (this.tipo === tipo) return;
        this.tipo = tipo;
        this.carregar();
    }

    public carregar() {
        if (!this.qtsSemanalId) return;
        this.carregando = true;
        this.erro = '';
        const req = this.tipo === 'horario'
            ? this.service.getPdfPorHorarioBlob(this.qtsSemanalId)
            : this.service.getPdfBlob(this.qtsSemanalId);
        req
            .then((blob: Blob) => {
                this.liberarUrl();
                this.pdfUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                this.carregando = false;
            })
            .catch(() => {
                this.carregando = false;
                this.erro = 'Não foi possível carregar o PDF.';
            });
    }

    private liberarUrl() {
        if (this.pdfUrl) {
            URL.revokeObjectURL(this.pdfUrl);
            this.pdfUrl = '';
        }
    }

    beforeUnmount() {
        this.liberarUrl();
    }
}
</script>

<style scoped>
.pdf-frame {
    width: 100%;
    height: calc(100vh - 260px);
    min-height: 500px;
    border: 1px solid #e5edf6;
    border-radius: 12px;
}
</style>
